import { get, post, put } from '../Services/http';
import { catchError } from './Error.action';
import { show as showNotification } from './Notification.action';
import { show as showPopup } from './AddToCartPopup.action';

export const CART_LOAD = 'CART_LOAD';
export const CART_LOAD_ERROR = 'CART_LOAD_ERROR';
export const CART_RECEIVE = 'CART_RECEIVE';
export const CART_SHOW_INFO = 'CART_SHOW_INFO';
export const CART_SHOW_POPUP = 'CART_SHOW_POPUP';
export const CART_HIDE = 'CART_HIDE';
export const CART_SHOW_CONFIGURATOR_ADD_POPUP = 'CART_SHOW_CONFIGURATOR_ADD_POPUP';

export const load = () => (dispatch, getState) => {
    return get('/api/cart')
        .then(response => response.json())
        .then(cart => dispatch(receive(cart)))
        .catch(ex => dispatch(catchError(ex, error => loadError(error))))
        ;
}

export const loadError = error => ({
    type: CART_LOAD_ERROR,
    payload: {
        error,
    }
})

export const receive = cart => ({
    type: CART_RECEIVE,
    payload: cart,
})

export const toggle = () => (dispatch, getState) => {
    dispatch(show(!getState().cart.showInfo));
}

const show = visible => ({
    type: CART_SHOW_INFO,
    payload: {
        showInfo: visible,
    }
})

const showConfiguratorAddPopUp = () => ({
    type: CART_SHOW_CONFIGURATOR_ADD_POPUP,
    payload: {
        showConfiguratorAddPopUp: true,
    }
})

export const hideConfiguratorAddPopUp = () => ({
    type: CART_SHOW_CONFIGURATOR_ADD_POPUP,
    payload: {
        showConfiguratorAddPopUp: false,
    }
})

export const add = ({ articleNumber, quantity = 1, nodeIdToShowNotification = null, notificationMessage = null, hash = '', configuratorId = '' }) => {
    return (dispatch) => {
        if (!quantity || isNaN(quantity) || parseFloat(quantity) <= 0) {
            return;
        }

        return post('/api/cart/add', { articleNumber, quantity: parseFloat(quantity), configuratorId: configuratorId })
            .then(response => response.json())
            .then(cart => {
                dispatch(receive(cart));
                // nodeIdToShowNotification && dispatch(showNotification(nodeIdToShowNotification, notificationMessage, hash));
                get(`/api/cart/relatedproducts?articleNumber=${articleNumber}`)
                    .then(response => response.json())
                    .then(relatedProductsModel => {
                        relatedProductsModel.product.quantity = quantity,
                        nodeIdToShowNotification && dispatch(showPopup(nodeIdToShowNotification, relatedProductsModel, hash, true));
                    })
            })
            .catch(ex => dispatch(catchError(ex, error => loadError(error))));
    }
}

export const addMultiple = (products, configuratorId) => {
    return (dispatch) => {
        const addToCartModel = [];
        for (const product of products) {
            const { articleNumber, confirmedQuantity } = product;            
            addToCartModel.push({ articleNumber : articleNumber, quantity : confirmedQuantity });            
        }

        return post('/api/cart/addconfigurator', { configuratorId, orderRows: addToCartModel })
            .then(response => response.json())
            .then(cart => {                
                dispatch(showConfiguratorAddPopUp());
            })
            .catch(ex => dispatch(catchError(ex, error => loadError(error))));
    };
}

export const addFromCalculator = (products) => {
    return (dispatch) => {
        const addToCartModel = [];
        for (const product of products) {
            const { articleNumber, quantity}  = product;
            addToCartModel.push({ articleNumber : articleNumber, quantity: quantity });
        }
        const firstProduct = products.find(x => x.quantity > 0);

        return post('/api/cart/addfromcalculator', { orderRows: addToCartModel})
            .then(response => response.json())
            .then(cart => {
                dispatch(receive(cart));
                get(`/api/cart/relatedproducts?articleNumber=${firstProduct.articleNumber}`)
                .then(response => response.json())
                .then(relatedProductsModel => {
                    relatedProductsModel.product.quantity = firstProduct.quantity,
                    dispatch(showPopup("addToCartPopup", relatedProductsModel, "hash", false));
                })
            })
            .catch(ex => dispatch(catchError(ex, error => loadError(error))));
    };
}

export const reorder = ({ orderId, nodeIdToShowNotification = null, notificationMessage = null, hash = '' }) => {
    if (orderId) {
        return (dispatch) => {
            return post('/api/cart/reorder', { orderId })
                .then(response => response.json())
                .then(cart => {
                    dispatch(receive(cart));
                    nodeIdToShowNotification && dispatch(showNotification(nodeIdToShowNotification, notificationMessage, hash));
                })
                .catch(ex => dispatch(catchError(ex, error => loadError(error))))
                ;
        }
    }
}

export const addFromRelatedProductsInCheckout = (articleNumber) => {
    return (dispatch) => {
        return post('/api/cart/add', { articleNumber, quantity: 1 })
            .then(response => response.json())
            .then(cart => dispatch(receive(cart)))
            .catch(ex => dispatch(catchError(ex, error => loadError(error))));
    }
}

export const update = (rowSystemId, quantity, isConfigurator, configuratorRowExists) => (dispatch) => {
    return put(`/api/cart/update`, { rowSystemId, quantity, isConfigurator, configuratorRowExists })
        .then(response => response.json())
        .then(cart => dispatch(receive(cart)))
        .catch(ex => dispatch(catchError(ex, error => loadError(error))))
        ;
}
